// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"v4-z","colorTextValue":"w4-z","swatches":"x4-z","collapseLink":"y4-z","isCollapsed":"z4-z","dropdown":"A4-z","disabled":"B4-z"};